<template>
  <v-card class="my-1">
    <v-toolbar flat dense>
      <v-toolbar-title>Logos</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <div class="logo-row">
        <div v-for="logo in logos" :key="logo.key" class="logo-tile">
          <image-chooser
            :value="logo.currentValue"
            subject="Logo"
            :image-type="['logo_square', 'logo_wide']"
            :upload-field-rules="logoUploadRules"
            :initial-value="logo.currentFrame.value"
            :null-component="HandSquare"
            null-text="Kein Logo eingestellt"
            large
            activator-fit="contain"
            :activator-height="140"
            @input="val => $emit('input', { key: logo.key, value: val })"
            @upload-file="$emit('upload', { setting: logo, fileElement: $event, types: ['logo_square', 'logo_wide'] })"
          >
            <template v-slot:uploadText>
              <v-col cols="12">Datei max. 2&nbsp;MB, transparenter Hintergrund, idealerweise .png. Seitenverhältnis bis 4,5:12, auch 1:1 möglich.</v-col>
            </template>
            <template v-slot:overlay="{ element }">
              <div v-if="element && element.image && element.image.hash && element.image.name" class="logo-tile__file">
                {{ element.image.name }}<template v-if="element.image.width && element.image.height"> ({{ element.image.width }}&times;{{ element.image.height }})</template>
              </div>
            </template>
          </image-chooser>
          <reset-icon class="logo-tile__reset" :setting="logo" @clear="$emit('clear', logo.key)" @set-here="$emit('set-here', logo.key)" />
          <div class="logo-tile__label">
            <span>{{ logoLabels[logo.type] }}</span>
            <v-tooltip bottom max-width="280">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" x-small class="ml-1">{{ mdiInformationOutline }}</v-icon>
              </template>
              <span>{{ logoExplanations[logo.type] }}</span>
            </v-tooltip>
          </div>
        </div>
      </div>

      <div v-if="logoIsText" class="d-flex align-center mt-4">
        <v-checkbox
          :input-value="logoIsText.currentValue"
          true-value="y"
          false-value="n"
          @change="$emit('input', { key: logoIsText.key, value: $event === 'y' })"
          dense
          hide-details
          class="mt-0 pt-0"
        >
          <template #label>
            <span class="text-body-2">Organisationsnamen nicht neben dem Logo anzeigen</span>
            <v-tooltip bottom max-width="280">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" x-small class="ml-1">{{ mdiInformationOutline }}</v-icon>
              </template>
              <span>Nützlich, wenn Ihr Logo bereits den Organisationsnamen enthält (kombinierte Wort/Bildmarke).</span>
            </v-tooltip>
          </template>
        </v-checkbox>
        <reset-icon :setting="logoIsText" @clear="$emit('clear', logoIsText.key)" @set-here="$emit('set-here', logoIsText.key)" />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mdiInformationOutline } from '@mdi/js'
import ResetIcon from '@/components/device/ResetIcon'
import ImageChooser from '@/components/device/ImageChooser'
import HandSquare from '@/components/icons/HandSquare'

const LOGO_LABELS = {
  webappLogo: 'Logo',
  mainLogo: 'Hauptlogo',
  cornerLogo: 'Ecklogo',
  spLogo: 'Logo',
}

const LOGO_EXPLANATIONS = {
  webappLogo: 'Wird an beiden Positionen verwendet: als Ecklogo oben rechts und als Hauptlogo im mittleren Bereich.',
  mainLogo: 'Wird im mittleren Bereich des Spendengeräts angezeigt.',
  cornerLogo: 'Wird in der oberen rechten Ecke des Spendengeräts angezeigt.',
  spLogo: 'Wird in der linken Ecke auf Ihrem Spendengerät angezeigt.',
}

export default {
  name: 'LogoGroup',
  components: { ResetIcon, ImageChooser },
  props: {
    logos: {
      type: Array,
      required: true,
    },
    logoIsText: {
      type: Object,
      default: null,
    },
  },
  data () {
    return {
      mdiInformationOutline,
      HandSquare,
      logoLabels: LOGO_LABELS,
      logoExplanations: LOGO_EXPLANATIONS,
      logoUploadRules: [
        file => !file || !(file.size > 2097152) || 'Maximal 2 MB!'
      ],
    }
  },
}
</script>

<style scoped>
.logo-row {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  align-items: flex-start;
}
.logo-tile {
  position: relative;
}
.logo-tile__reset {
  position: absolute;
  top: 4px;
  right: 4px;
}
.logo-tile__label {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 13px;
  color: rgba(0, 0, 0, .6);
  margin-top: 6px;
}
.logo-tile__file {
  position: absolute;
  left: 8px;
  top: 8px;
  background: rgba(255, 255, 255, .85);
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 11px;
  color: rgba(0, 0, 0, .7);
  max-width: calc(100% - 16px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
